var addressCount = 0;
var addresses = [];
var editId;
var addressRequired = true;

var bootstrapButton = $.fn.button.noConflict();
$.fn.bootstrapBtn = bootstrapButton;

$('#confirmRegisterBtn').hide();
$('#searchInput').hide();

$(function () {
    $('.box__heading').matchHeight();
});

$("a[id^='packageMoreInfoLink']").click(function (e) {
    e.stopPropagation();
    e.preventDefault();

    if (e.target.id === 'packageMoreInfoLink_1') {
        $('#bundle2info').hide();
        $('#bundle3info').hide();
    }
    if (e.target.id === 'packageMoreInfoLink_2') {
        $('#bundle2info').show();
        $('#bundle3info').hide();
    }
    if (e.target.id === 'packageMoreInfoLink_3') {
        $('#bundle2info').show();
        $('#bundle3info').show();
    }

    $('#info').modal('show');
});



function getPrice() {
    currentPrice = 0;

    if (selectedGroupCount > 0)
        currentPrice = initialPrice;

    if (selectedGroupCount > 1)
        currentPrice += (selectedGroupCount - 1) * additionalPrice;

    if (currentPrice > maxPrice)
        currentPrice = maxPrice;

    var additionalCost = 0;
    if (addressCount > 0)
        additionalCost = ((currentPrice * additionalSearchPricePercentage) * (addressCount - 1));
    if (entities > 1)
        additionalCost += ((currentPrice * additionalSearchPricePercentage) * (entities - 1));

    currentPrice += additionalCost;

    $('#price').text(currentPrice.toFixed(2))
    if (currentPrice > 0) {
        $('.quick-view-holder').addClass('-active');
        $('.site-footer > .container').hide();
    }
}

function addEntity(scrollTo, title, forename, surname, companyName) {
    var source = $('#nameTemplate').html();
    var template = Handlebars.compile(source);

    $('#entities').append(template({ entities: entities, title: title, forename: forename, surname: surname, companyName: companyName }));
    entities++;
    getPrice();
    CheckAdditional();

    if ((!additionalAddressesAndEntities && addressCount > 0) || addressCount >= additionalAddresses) {
        $('#postcodeInputDiv').hide();
        $('#addAddressBtn').hide();
    }
    if (scrollTo) {
        //if ($('#Entities_0__CompanyName').length == 0) {
        //    $('#Entities_' + (entities - 1) + '__Title').focus();
        //} else {
        //    $('#Entities_' + (entities - 1) + '__CompanyName').focus();
        //}
    }

    $('.validate').blur(function (event) {
        validate(event)
    });
}

function PostcodeSelect() {
    var data = getFullAddress($('#addressDialog').find(':selected').val());
    if (data === undefined)
        return;

    var source = $('#addressLine').html();
    var template = Handlebars.compile(source);

    $('#addressList').append(template(data));
    $("#addressDialog").dialog("close");
    $('#postcodeInputDiv').hide();
    $('#postcodeInput').val('');

    $('html, body').animate({
        scrollTop: $("#entityTitle").offset().top
    }, 500);
    addressCount++;
    getPrice();
    CheckAdditional();
}

function confirmAddress() {
    var template = Handlebars.compile($('#addressLine').html());

    $('#AddressPafId').val('');

    if (!validateAddress())
        return;

    var data = {
        BuildingNumber: $('#AddressHouseNumber').val(),
        BuildingName: $('#AddressHouseName').val(),
        Street: $('#AddressStreet').val(),
        Address2: $('#AddressAddress2').val(),
        Address3: $('#AddressAddress3').val(),
        Town: $('#AddressTown').val(),
        County: $('#AddressCounty').val(),
        Postcode: $('#AddressPostcode').val(),
        PafId: $('#AddressPafId').val(),
        AddressCount: addressCount
    };
    if (editId != undefined && editId != -1) {
        removeAddress(editId);
        data.AddressCount = addressCount - 1;
        editId = undefined;
    } else {
        addressCount++;
    }

    clearAddressInputDialog();
    var addressLine = data.BuildingName + " " + data.BuildingNumber + " " + data.Street;
    data.FirstAddressLine = addressLine;
    [data.Address2, data.Address3, data.Town, data.County, data.Postcode].forEach(function (item) {
        if (item !== "")
            addressLine += ", " + item;
    });
    addressLine = addressLine.toUpperCase();
    data.AddressLineOutput = addressLine;

    $('#addressList').append(template(data));
    $('#addressInput').remove();
    $('#postcodeInput').val('');
    //$('#postcodeInput').hide();
    $("#addressInputDialog").dialog("close");
    $('html, body').animate({
        scrollTop: $("#entityTitle").offset().top
    }, 500);
    getPrice();
    CheckAdditional();
}

function addAddress() {
    $('#Validator_Postcode').html('');
    $('#postcodeInputDiv').show();
    if (addressCount > 0) {
        $('#RemoveExtraAddBtn').show();
    } else {
        $('#RemoveExtraAddBtn').hide();
    }
    $('#postcodeInput').val('');
    $('#postcodeInput').focus();

    $('#addEntityBtn').hide();
}

function removeEntity(id) {
    $('#entity' + id).remove();

    for (i = id; i < entities; i++) {
        $('#entity' + (i + 1)).attr({ name: 'entity' + i, id: 'entity' + i });
        $('#Entities_' + (i + 1) + '__Title').attr({ name: 'Entities[' + i + '].Title', id: 'Entities_' + i + '__Title' });
        $('#Entities_' + (i + 1) + '__Forename').attr({ name: 'Entities[' + i + '].Forename', id: 'Entities_' + i + '__Forename' });
        $('#Entities_' + (i + 1) + '__Surname').attr({ name: 'Entities[' + i + '].Surname', id: 'Entities_' + i + '__Surname' });
        $('#Entities_' + (i + 1) + '__CompanyName').attr({ name: 'Entities[' + i + '].CompanyName', id: 'Entities_' + i + '__CompanyName', onchange: "companiesHouseCheck();" });
        $('#CHCheckBtn_' + (i + 1)).attr({ name: 'CHCheckBtn_' + i, id: 'CHCheckBtn_' + i });

        $('#removeEntity' + (i + 1)).attr({ id: 'removeEntity' + i, onclick: 'removeEntity(' + i + ');' });
    }

    entities--;
    getPrice();
    CheckAdditional();
    if ($('#Type').val() === 'Business')
        companiesHouseCheck();
}

function companiesHouseCheck() {
    addressRequired = true;
    for (var x = 0; x < entities; x++) {
        var companyName = $('#Entities_' + x + '__CompanyName').val();

        if (companyName === undefined)
            continue;

        companyName = companyName.trim();
        var lastWord = companyName.split(' ').pop().toUpperCase();
        if (corporateIdentifiers.indexOf(lastWord) === -1) {
            $.ajax('/Service/CompaniesHouseCheck', {
                'async': false, 'type': 'POST',
                'data': {
                    id: companyName,
                },
                'success': function (data) {
                    if (data === true) {
                        addressRequired = false;
                    }
                },
                'error': function (data) {
                    console.log(data);
                }
            });
        } else {
            addressRequired = false;
        }
    }

    if (addressRequired) {
        $('#label-hint').html('An address is required<br />for this type of business');
    } else {
        $('#label-hint').html('An address is optional but may <br>give a more complete search result');
    }
}

function ManualAddress() {
    editId = -1;
    clearAddressValidators();
    $("#addressInputDialog").dialog();
    $("#addressInputDialog").dialog('open');
}

function CheckAdditional() {
    $('#addEntityBtn').show();

    if (($('#address0').length == 0 && $('#Entities_0__CompanyName').length == 0)
        || entities >= additionalEntities + 1 || (addressCount > 1 && !additionalAddressesAndEntities)
        || ($('#Entities_0__CompanyName').length > 0 && $('#Entities_0__CompanyName').val() == "")) {
        $('#addEntityBtn').hide();
    }

    $('#addAddressBtn').hide();
    $('#postcodeInputDiv').hide();
    if (addressCount == 0 || (addressCount <= additionalAddresses && (entities == 1 || additionalAddressesAndEntities))) {
        if ($('#address0').length == 0) {
            $('#postcodeInputDiv').show();
            if (addressCount > 0) {
                $('#RemoveExtraAddBtn').show();
            } else {
                $('#RemoveExtraAddBtn').hide();
            }
        } else {
            $('#addAddressBtn').show();
        }
    }
}

function submitSearch(option, nextType) {
    var valid = validate();
    if (!valid)
        return false;

    if (option == 'GoToBasket') {
        $('#goToBasket').val(true);
    } else {
        $('#goToBasket').val(false);
    }
    $('#nextType').val(nextType);
    $('#goToBasketBtn').attr("disabled", "disabled");
    $('#searchForm').submit();
}

function validate(event) {
    $('#Validator_Registers').html('');
    $('#Validator_Postcode').html('');
    if (selectedGroupCount === 0) {
        $('#Validator_Registers').html('Please select at least one register');
    }

    var valid = true;
    var target = event ? event.currentTarget.id : null;

    for (i = 0; i < entities; i++) {
        if ($('#Type').val() == "Person") {
            if (target === 'Entities_' + i + '__Surname' || target === null) {
                $('#Validator_' + i + '__Name').html('');
                if ($('#Entities_' + i + '__Surname').val() == "" || ($('#Entities_' + i + '__Title').val() + $('#Entities_' + i + '__Forename').val() == "")) {
                    $('#Validator_' + i + '__Name').html('Enter a full name');
                    valid = false;
                }
            }
        } else {
            $('#Validator_' + i + '__CompanyName').html('');
            if ($('#Entities_' + i + '__CompanyName').val() == "") {
                $('#Validator_' + i + '__CompanyName').html('Please enter a company name');
                valid = false;
            }
        }
    }

    if (target === null) {
        $('#Validator_Postcode').html('');
        if ((addressRequired && addressCount == 0 && $('#addressLineOutput0').length == 0) ||
            $('#postcodeInput')[0].value.length != 0) {
            $('#Validator_Postcode').html('Enter a complete address');
            valid = false;
        }
    }

    if (!valid)
        return false;

    return true;
}

function removeAddress(id, reduceCount) {
    if (id == -1) {
        clearAddressInputDialog();
        $("#addressInputDialog").dialog("close");
        CheckAdditional();
        return;
    }

    $('#address' + id).remove();
    $('#addressLine' + id + 'Div').remove();
    $('#addressLineOutput' + id).remove();
    $('#postcodeInput').val('');

    for (i = id; i < addressCount; i++) {
        ['Postcode', 'HouseNumber', 'HouseName', 'Street', 'Address2', 'Address3', 'Town', 'County', 'PafId'].forEach(function (item) {
            var newId = $('[name="Addresses[' + (i + 1) + '].' + item + '"]').attr('id');
            if (newId !== undefined && newId !== '') {
                newId = newId.slice(0, -1) + i;
                $('[name="Addresses[' + (i + 1) + '].' + item + '"]').attr({
                    name: 'Addresses[' + i + '].' + item,
                    id: newId
                });
            }
        });

        $('#addressLineOutput' + (i + 1)).attr({ id: 'addressLineOutput' + i });
        $('#RemoveAddress' + (i + 1)).attr({ id: 'RemoveAddress' + i, onclick: 'removeAddress(' + i + ', true); return false;' });
        $('#EditAddress' + (i + 1)).attr({ id: 'EditAddress' + i, onclick: 'editAddress(' + i + '); return false;' });
        $('#address' + (i + 1)).attr({ id: 'address' + i });
        $('#addressLine' + (i + 1) + 'Div').attr({ id: 'addressLine' + i + 'Div' });

        $('#FirstAddressLine' + (i + 1)).attr({ name: 'Addresses[' + i + '].FirstLine', id: 'FirstAddressLine' + i});
    }
    clearAddressInputDialog();
    $("#addressInputDialog").dialog("close");
    $('html, body').animate({
        scrollTop: $("#entityTitle").offset().top
    }, 500);

    if (reduceCount) {
        addressCount--;
        getPrice();
    }
    CheckAdditional();
}

function editAddress(id) {
    var data = inputsToObject(id);
    editId = id;
    $('#AddressHouseNumber').val(data.BuildingNumber);
    $('#AddressHouseName').val(data.BuildingName);
    $('#AddressStreet').val(data.Street);
    $('#AddressAddress2').val(data.Address2);
    $('#AddressAddress3').val(data.Address3);
    $('#AddressTown').val(data.Town);
    $('#AddressCounty').val(data.County);
    $('#AddressPostcode').val(data.Postcode);
    $('#AddressPafId').val(data.PafId);

    clearAddressValidators();
    $("#addressInputDialog").dialog();
    $("#addressInputDialog").dialog('open');
}

function inputsToObject(id) {
    var data = {
        BuildingNumber: $('#BuildingNumber' + id).val(),
        BuildingName: $('#BuildingName' + id).val(),
        Street: $('#Street' + id).val(),
        Address2: $('#Address2' + id).val(),
        Address3: $('#Address3' + id).val(),
        Town: $('#Town' + id).val(),
        County: $('#County' + id).val(),
        Postcode: $('#Postcode' + id).val(),
        PafId: $('#PafId' + id).val(),
        AddressCount: addressCount
    };

    var addressLine = data.BuildingName + " " + data.BuildingNumber + " " + data.Street;
    [data.Address2, data.Address3, data.Town, data.County, data.Postcode].forEach(function (item) {
        if (item != "")
            addressLine += ", " + item;
    });
    addressLine = addressLine.toUpperCase();
    data.AddressLineOutput = addressLine;

    return data;
}

function clearAddressInputDialog() {
    $('#AddressHouseNumber').val("");
    $('#AddressHouseName').val("");
    $('#AddressStreet').val("");
    $('#AddressAddress2').val("");
    $('#AddressAddress3').val("");
    $('#AddressTown').val("");
    $('#AddressCounty').val("");
    $('#AddressPostcode').val("");
    $('#AddressPafId').val("");
}

function addAddressDetails(buildingNumber, buildingName, street, address2, address3, town, county, postcode, pafId) {
    var template = Handlebars.compile($('#addressLine').html());
    var data = {
        BuildingNumber: buildingNumber,
        BuildingName: buildingName,
        Street: street,
        Address2: address2,
        Address3: address3,
        Town: town,
        County: county,
        Postcode: postcode,
        PafId: pafId,
        AddressCount: addressCount
    };
    var addressLine = data.BuildingName + " " + data.BuildingNumber + " " + data.Street;
    [data.Address2, data.Address3, data.Town, data.County, data.Postcode].forEach(function (item) {
        if (item != "")
            addressLine += ", " + item;
    });
    addressLine = addressLine.toUpperCase();
    data.AddressLineOutput = addressLine;

    $('#addressList').append(template(data));
    addressCount++;
}

function selectGroup(id) {
    var selected = false;
    if ($('#groups_' + id).val() == 'selected') {
        $('#groupdiv_' + id).removeClass('-selected');
        $('#groups_' + id).val('unselected');
        selectedGroupCount--;
    }
    else {
        $('#groupdiv_' + id).addClass('-selected');
        $('#groups_' + id).val('selected');
        selectedGroupCount++;
        selected = true;
    }
    $('#confirmRegisterBtn').show();

    getPrice();
    if (maxPrice <= currentPrice && selected) {
        for (var x = 0; x < groupCount; x++) {
            if ($('#groups_' + x).val() != 'selected') {
                $('#groupdiv_' + x).addClass('-selected');
                $('#groups_' + x).val('selected');
                selectedGroupCount++;
            }
        }
        $('#Validator_Registers').html('You have chosen to search 3 or more Registers.<br>As the fee is the same, we have defaulted your search to All Registers');
    } else {
        $('#Validator_Registers').html('');
    }

    if (selectedGroupCount > groupCount)
        selectedGroupCount = groupCount;
}

function showSearchInput() {
    if (selectedGroupCount == 0) {
        $('#Validator_Registers').html('Please select at least one register');
    } else {
        $('#searchInput').show();
        $('#postcodeInputDiv').show();
        CheckAdditional();

        $('html, body').animate({
            scrollTop: $("#searchInput").offset().top
        }, 500);
    }
}

function selectPackage(groups) {
    for (var x = 0; x < groupCount; x++) {
        $('#groupdiv_' + x).removeClass('-selected');
        $('#groups_' + x).val('unselected');
    }
    selectedGroupCount = 0;

    groups.split(",").forEach(function (item) {
        $('#groupdiv_' + item).addClass('-selected');
        $('#groups_' + item).val('selected');
        selectedGroupCount++;
    });

    getPrice();

    showSearchInput();
}
